import React from 'react'

const ButtonLoader = () => {
  return (
    <span className='flex items-center'>
        <span className='spin-loader'></span>Loading...
    </span>
  )
}

export default ButtonLoader